import React from 'react';
import ToshokanPassPage from '@/features/toshokan/ToshokanPassPage';

export default function PricingPage() {
  return <ToshokanPassPage />;
}
